export const ACCOUNT_USER_LIKE_BRAND_DETAIL_MODEL = {
  totalAddCount: 0,
  totalRemoveCount: 0,
  totalClickCount: 0,
};

/**
 *  유저 상세 > 좋아요한 브랜드 정보 > 좋아요한 브랜드 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL = {
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  브랜드 상태
   */
  storeStatus: null,
};

/**
 *  유저 상세 > 좋아요한 브랜드 정보 > 좋아요한 브랜드 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

export const ACCOUNT_USER_LIKE_BRAND_LIST_MODEL = {
  list: [],
  totalCnt: 0,
};

/**
 *  유저 상세 > 좋아요한 브랜드 정보 > 좋아요한 브랜드 타임라인 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_FILER_OPTION_MODEL = {
  /**
   *  브랜드 ID
   */
  storeId: null,
  /**
   *  브랜드명
   */
  storeName: null,
  /**
   *  활동 내역
   */
  actionLogType: null,
  /**
   *  활동 시간
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  유저 상세 > 좋아요한 브랜드 정보 > 좋아요한 브랜드 타임라인 리스트 정렬 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

export const ACCOUNT_USER_LIKE_BRAND_LOG_LIST_MODEL = {
  likeBrandLogList: [],
  totalCnt: 0,
};
